import React from 'react';
import { Mail, Phone, ArrowUpRight, Shield } from 'lucide-react';
interface FooterProps {
  onNavigate: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer className="relative bg-slate-950 text-white overflow-hidden" data-id="element-134">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-950/20 via-transparent to-indigo-950/20 pointer-events-none" data-id="element-135"></div>

      {/* Main Footer Content */}
      <div className="relative container mx-auto px-4 md:px-6 pt-16 pb-8" data-id="element-136">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 mb-12" data-id="element-137">
          {/* Brand Column */}
          <div className="lg:col-span-1 space-y-6" data-id="element-138">
            <div className="flex items-center gap-3 cursor-pointer group" onClick={() => onNavigate('home')} data-id="element-139">
              <div className="flex items-center justify-center h-10 w-10 rounded-xl bg-gradient-to-br from-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-500/20 group-hover:shadow-blue-500/40 transition-shadow" data-id="element-140">
                <Shield className="h-5 w-5" data-id="element-141" />
              </div>
              <div className="flex flex-col" data-id="element-142">
                <span className="text-lg font-semibold text-white leading-tight group-hover:text-blue-400 transition-colors" data-id="element-143">
                  smartprotect24
                </span>
                <span className="text-xs text-slate-500 leading-tight" data-id="element-144">
                  Gründlich. Einfach. Digital.
                </span>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed max-w-xs" data-id="element-145">
              Versicherungsanalyse- und Vermittlungsservice. Unabhängig, digital
              und transparent.
            </p>
          </div>

          {/* Schnellzugriff Column */}
          <div data-id="element-146">
            <h3 className="mb-5 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-147">
              Schnellzugriff
            </h3>
            <ul className="space-y-3" data-id="element-148">
              <li data-id="element-149">
                <button onClick={() => onNavigate('rechner')} className="group flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors" data-id="element-150">
                  <span data-id="element-151">Rechner</span>
                  <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" data-id="element-152" />
                </button>
              </li>
              <li data-id="element-153">
                <button onClick={() => onNavigate('blog')} className="group flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors" data-id="element-154">
                  <span data-id="element-155">Blog</span>
                  <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" data-id="element-156" />
                </button>
              </li>
              <li data-id="element-157">
                <button onClick={() => onNavigate('beratung')} className="group flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors" data-id="element-158">
                  <span data-id="element-159">Beratung</span>
                  <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" data-id="element-160" />
                </button>
              </li>
              <li data-id="element-161">
                <button onClick={() => onNavigate('app')} className="group flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors" data-id="element-162">
                  <span data-id="element-163">Kunden-App</span>
                  <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" data-id="element-164" />
                </button>
              </li>
            </ul>
          </div>

          {/* Rechtliches Column */}
          <div data-id="element-165">
            <h3 className="mb-5 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-166">
              Rechtliches
            </h3>
            <ul className="space-y-3" data-id="element-167">
              <li data-id="element-168">
                <a href="#" className="group flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors" data-id="element-169">
                  <span data-id="element-170">Impressum</span>
                  <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" data-id="element-171" />
                </a>
              </li>
              <li data-id="element-172">
                <a href="#" className="group flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors" data-id="element-173">
                  <span data-id="element-174">Datenschutz</span>
                  <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" data-id="element-175" />
                </a>
              </li>
              <li data-id="element-176">
                <button onClick={() => onNavigate('faq')} className="group flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors" data-id="element-177">
                  <span data-id="element-178">FAQ</span>
                  <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" data-id="element-179" />
                </button>
              </li>
            </ul>
          </div>

          {/* Kontakt Column */}
          <div data-id="element-180">
            <h3 className="mb-5 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-181">
              Kontakt
            </h3>
            <ul className="space-y-4" data-id="element-182">
              <li data-id="element-183">
                <a href="mailto:info@smartprotect24.de" className="flex items-center gap-3 text-sm text-slate-400 hover:text-white transition-colors group" data-id="element-184">
                  <div className="flex items-center justify-center h-8 w-8 rounded-lg bg-slate-900 border border-slate-800 group-hover:border-slate-700 group-hover:bg-slate-800 transition-all" data-id="element-185">
                    <Mail className="h-4 w-4" data-id="element-186" />
                  </div>
                  <span data-id="element-187">info@smartprotect24.de</span>
                </a>
              </li>
              <li data-id="element-188">
                <a href="tel:+4912345678" className="flex items-center gap-3 text-sm text-slate-400 hover:text-white transition-colors group" data-id="element-189">
                  <div className="flex items-center justify-center h-8 w-8 rounded-lg bg-slate-900 border border-slate-800 group-hover:border-slate-700 group-hover:bg-slate-800 transition-all" data-id="element-190">
                    <Phone className="h-4 w-4" data-id="element-191" />
                  </div>
                  <span data-id="element-192">+49 123 456 78</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-193">
          <p className="text-xs text-slate-500" data-id="element-194">
            © {new Date().getFullYear()} smartprotect24. Alle Rechte
            vorbehalten.
          </p>
          <p className="text-xs text-slate-600" data-id="element-195">
            Angaben ohne Gewähr. Keine Steuer- oder Rechtsberatung.
          </p>
        </div>
      </div>
    </footer>;
}